import React, { useContext, useEffect } from 'react';
import { ProfileContext } from '../../../context/ProfileContext';
import StyledButton from '../../../components/Button/Button';
import { useNavigate } from 'react-router-dom';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import TopNav from '../../../components/TopNav/TopNav';
import { Typography, Box, Container } from '@mui/material';
import './ChangeProfilePic.css';

const ChangeProfilePic: React.FC = () => {
  const context = useContext(ProfileContext);
  if (!context) {
    throw new Error('ProfileContext must be used within a ProfileProvider');
  }

  const {
    profilePicPreview,
    handleProfilePicChanged,
    tempProfilePic,
    handleProfilePic,
  } = context;

  const navigate = useNavigate();

  useEffect(() => {
    if (!profilePicPreview) {
      navigate('/supervisor/edit-profile');
    }
  }, [profilePicPreview, navigate]);

  const handleUpload = () => {
    handleProfilePicChanged();
    handleProfilePic(tempProfilePic);
    navigate(-1);
  };

  return (
    <StyledBgContainer>
      <TopNav showArrow={true} />
      <Container maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              color: 'white',
              fontFamily: 'Opensans',
              fontWeight: '700',
            }}
          >
            Change Profile Picture
          </Typography>
          <Typography variant="body2" sx={{ color: 'grey', mt: 1, mb: 3 }}>
            Upload a new picture to be used along side your name to identify you
            as the user.
          </Typography>

          <Box
            className="new-profile"
            sx={{
              width: '220px',
              height: '220px',

              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <img
              src={profilePicPreview || ''}
              alt="Profile Preview"
              className="profile-preview"
            />
          </Box>

          <StyledButton onClick={handleUpload} sx={{ marginTop: '13vh' }}>
            Upload New
          </StyledButton>
        </Box>
      </Container>
    </StyledBgContainer>
  );
};

export default ChangeProfilePic;
